import {AlarmType} from '../interfaces/AlarmType';

export const STATUSES = [
  {
    key: 'active',
    name: 'Active',
  },
  {
    key: 'inactive',
    name: 'Inactive',
  },
] as const;

export const COMMUNICATION_NODE_STATUSES = [
  {key: 'all', name: 'All'},
  {key: 'active', name: 'Active'},
  {key: 'inactive', name: 'Inactive'},
  {key: 'activated', name: 'Activated'},
  {key: 'deactivated', name: 'Deactivated'},
  {key: 'connected', name: 'Connected'},
  {key: 'disconnected', name: 'Disconnected'},
  {key: 'unacknowledged', name: 'Unacknowledged'},
] as const;

export const ASSET_STATUSES = [
  {key: 'all', name: 'All'},
  {key: 'checked_in', name: 'Checked In'},
  {key: 'checked_out', name: 'Checked Out'},
  {key: 'active', name: 'Active'},
  {key: 'inactive', name: 'Inactive'},
  {key: 'activated', name: 'Activated'},
  {key: 'deactivated', name: 'Deactivated'},
  {key: 'unacknowledged', name: 'Unacknowledged'},
  {key: 'surface', name: 'Surface'},
  {key: 'underground', name: 'Underground'},
  {key: 'none', name: 'None'},
] as const;

export const ALARM_MODULE_STATUS_OPTIONS: {
  value: AlarmType['status'] | 'all' | 'unacknowledged';
  label: string;
}[] = [
  {
    value: 'active',
    label: 'Active',
  },
  {
    value: 'inactive',
    label: 'Inactive',
  },
  {
    value: 'all',
    label: 'All',
  },
  {
    value: 'unacknowledged',
    label: 'Unacknowledged',
  },
];

export const AMS_SENSOR_STATUS_OPTIONS: {
  value: 'active' | 'inactive' | 'all' | 'unacknowledged';
  label: string;
}[] = [
  {
    value: 'active',
    label: 'Active',
  },
  {
    value: 'inactive',
    label: 'Inactive',
  },
  {
    value: 'all',
    label: 'All',
  },
  {
    value: 'unacknowledged',
    label: 'Unacknowledged',
  },
];

export const BELT_STATUS_OPTIONS: {
  value: 'active' | 'inactive' | 'all' | 'unacknowledged';
  label: string;
}[] = [
  {
    value: 'active',
    label: 'Active',
  },
  {
    value: 'inactive',
    label: 'Inactive',
  },
  {
    value: 'all',
    label: 'All',
  },
  {
    value: 'unacknowledged',
    label: 'Unacknowledged',
  },
];

export const LIVE_MODE_OPTIONS = [
  {key: 'live', name: 'Live'},
  {key: 'snapshot', name: 'Snapshot'},
] as const;

export type Status = (typeof STATUSES)[number]['key'];
export type CommunicationNodeStatus =
  (typeof COMMUNICATION_NODE_STATUSES)[number]['key'];
export type AssetStatus = (typeof ASSET_STATUSES)[number]['key'];
export type AlarmModuleStatus =
  (typeof ALARM_MODULE_STATUS_OPTIONS)[number]['value'];
export type AmsSensorStatus =
  (typeof AMS_SENSOR_STATUS_OPTIONS)[number]['value'];
export type BeltStatus = (typeof BELT_STATUS_OPTIONS)[number]['value'];
export type LiveMode = (typeof LIVE_MODE_OPTIONS)[number]['key'];
